import React from "react";
import { GC_USER_ID, GC_AUTH_TOKEN } from "../constants";
import { useNavigate } from "react-router-dom";
import Dropdown from "./Dropdown";
import localForage from 'localforage';

function UserSettings(props) {
	const navigate = useNavigate();

	const logout = () => {
		localStorage.removeItem(GC_USER_ID);
		localStorage.removeItem(GC_AUTH_TOKEN);

        localForage.removeItem('auth_token_forage').then(function() {
            // console.log("Logged out!");
        });

		// localStorage.removeItem("Settings.treeStates");
		navigate("/login");
	};

	return (
		<div>
			<Dropdown
				logout={logout}
				isAuthenticated={true}
				user={props.user}
				settings={props.settings}
			/>
		</div>
	);
}

export default UserSettings;
